




































import { Vue, Component, Prop } from 'vue-property-decorator'
import DeadlineTimer from 'components/DeadlineTimer.vue'
import { format, date } from 'quasar'

@Component({
  components: {
    DeadlineTimer
  }
})
export default class DeadlineTimerCountdown extends Vue {
  pad = format.pad
  precision = 60000

  @Prop({ type: String, default: 'text-overline text-info line-dense q-mb-md'})
  dateClass!: string

  @Prop({ type: String, default: 'text-h2 q-mx-xs'})
  counterClass!: string

  @Prop({ type: String, default: 'text-info hidden-'})
  subtitleClass!: string

  get deadlineTime () {
    const deadline = new Date(this.$attrs.deadline)
    return date.formatDate(deadline.getTime() , 'dddd, HH:mm')
  }

  get deadlineDate () {
    const deadline = new Date(this.$attrs.deadline)
    return date.formatDate(deadline.getTime() , 'D MMMM YYYY')
  }
}
